import { Box, Paper, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Outlet, useLocation } from 'react-router-dom';

export function AuthLayout() {
  const theme = useTheme();
  const location = useLocation();
  const isLogin = location.pathname === '/login';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        background: isLogin 
          ? `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.15)} 0%, ${alpha(theme.palette.primary.light, 0.05)} 100%)`
          : 'linear-gradient(120deg, #ff9a9e 0%, #fecfef 99%, #fecfef 100%)',
        p: { xs: 2, sm: 4 },
        ...(isLogin ? {} : {
          '&::before': {
            content: '"🎈"',
            position: 'absolute',
            fontSize: '120px',
            top: '10%',
            left: '5%',
            animation: 'floatBalloons 6s ease-in-out infinite alternate',
            opacity: 0.8,
            zIndex: 0,
          },
          '&::after': {
            content: '"🧸"',
            position: 'absolute',
            fontSize: '150px',
            bottom: '5%',
            right: '8%',
            animation: 'wobble 4s ease-in-out infinite alternate',
            opacity: 0.8,
            zIndex: 0,
          }
        }),
      }}
    >
      {/* Additional decorative background elements */}
      {!isLogin && (
        <>
          <Box sx={{
            position: 'absolute',
            top: '20%',
            right: '15%',
            fontSize: '80px',
            animation: 'floatBalloons 5s ease-in-out infinite alternate-reverse',
            opacity: 0.7,
            zIndex: 0,
          }}>
            🌟
          </Box>
          <Box sx={{
            position: 'absolute',
            bottom: '20%',
            left: '10%',
            fontSize: '100px',
            animation: 'wobble 7s ease-in-out infinite alternate-reverse',
            opacity: 0.6,
            zIndex: 0,
          }}>
            🚀
          </Box>
        </>
      )}

      <Paper
        elevation={0}
        sx={{
          position: 'relative',
          zIndex: 1,
          width: '100%',
          maxWidth: isLogin ? 850 : 480,
          p: isLogin ? 0 : { xs: 4, sm: 6 },
          borderRadius: isLogin ? '20px' : '40px', 
          bgcolor: isLogin ? 'transparent' : alpha(theme.palette.background.paper, 0.95),
          boxShadow: isLogin ? 'none' : '0px 20px 50px rgba(0,0,0,0.1)',
          border: isLogin ? 'none' : '4px solid #fff', 
        }}
      >
        <Outlet />
      </Paper>

      {/* Global animations for fun floating emojis */}
      <style>
        {`
          @keyframes floatBalloons {
            0% { transform: translateY(0px) rotate(-5deg); }
            100% { transform: translateY(-30px) rotate(5deg); }
          }
          @keyframes wobble {
            0% { transform: rotate(-10deg) scale(0.9); }
            100% { transform: rotate(10deg) scale(1.1); }
          }
        `}
      </style>
    </Box>
  );
}

